export default import.meta.ROLLDOWN_FILE_URL_5NTr6cc6NRqYy5jNE$FD$A